import { v4 as uuidv4 } from "uuid";

const generate = (): string => uuidv4();

const uuidService = {
  generate,
};

export default uuidService;
